import { defineComponent } from 'vue';
import { prepareComponentOptions, useController } from 'zova';
import { ControllerIcon } from '../../component/icon/controller.jsx';
export const ZIcon = defineComponent(_props => {
  useController(ControllerIcon, undefined, undefined);
  return () => {};
}, prepareComponentOptions());